module.exports = __webpack_public_path__ + "static/img/67031554974898_.pic_hd.1d7f5d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/67031554974898_.pic_hd.jpg
// module id = dwbX
// module chunks = 2